  export const baseEnvironment = {
    version: "© INOVIA 2026 - v1.0.0 - 2026.02.27.01",
  }
  
